<template>
  <div class="wrap2" ref="textowrapper">
    <div class="row align-center">
      <div class="small-10 medium-10 large-10 columns">
          <div class="row align-center">
            <Transition name="slide-fade">
              <div v-show="show"
                   class="small-12 small-centered medium-12 medium-centered large-10 large-centered columns tc">
                <p class="faculdade_texto1"
                   v-if="$store.state.faculdade?.texto1.length > 0">
                  {{ $store.state.faculdade?.texto1 }}
                </p>
                <Button
                    v-if="showButton()"
                    @click="showText = !showText"
                    class="btn"
                    :text="buttonText" />
                <p class="faculdade_texto2"
                   :class="{'nomargintop' : $store.state.faculdade?.texto1.length == 0}"
                   v-show="showText || $store.state.faculdade?.texto1.length == 0">
                  {{ $store.state.faculdade?.texto2 }}
                </p>
              </div>
            </Transition>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../components/Button.vue";

export default {
  name: "FaculdadeIntro",
  components:{
    Button
  },
  data(){
    return {
      show: false,
      showText: false,
    }
  },
  computed:{
    buttonText(){
      if(!this.showText && this.$store.state.faculdade?.texto1.length > 0){
        return this.$translate('UMA_LANG_FACULDADE_VERMAIS');
      }else{
        return this.$translate('UMA_LANG_FACULDADE_VERMENOS');
      }
    }
  },
  mounted() {
    window.addEventListener("scroll",()=>{
      if(this.isOnViewPort(this.$refs.textowrapper)){
        this.show = true;
      }
    });
    if(this.isOnViewPort(this.$refs.textowrapper)){
      this.show = true;
    }
  },
  methods:{
    showButton(){
      return (
          this.$store.state.faculdade?.texto1.length > 0 &&
          this.$store.state.faculdade?.texto2.length > 0 )
    },
    isOnViewPort(el){
      var rect = el.getBoundingClientRect();
      return (
          rect.bottom >= 0 &&
          rect.top <= window.innerHeight &&
          rect.right >= 0 &&
          rect.left <= window.innerWidth
      )
    }
  }
}
</script>

<style scoped>
.wrap2{
  padding-top: 90px;
  padding-bottom: 90px;
}

.btn{
  margin: 0 auto;
  background-color: #080647;
  width: 290px;
  border: 2px solid white;
}

.btn.withmargin{
  margin-bottom: 41px;
}

.btn:hover {
  background-color: white;
  color: #080647;
  border: 2px solid #080647;
  transition: 900ms ease-in-out;

}

/*218*/
.row .row{
  margin-left: 0;
  margin-right: 0;
}

.slide-fade-enter-active {
  opacity: 1;
  transition-property: opacity, transform;
  transition-duration: .8s, 1s;
  transition-timing-function: ease-in, ease-in;
  transition-delay: 0.2s, 0.2s;
  transform: translate3D(0,0px,0);
}

.slide-fade-enter-from{
  opacity: 0;
  transform: translate3D(0,-20px,0);
}
/*70*/
.faculdade_texto1 {
  font-family: "PT Sans Italic";
  font-size: 25px;
  line-height: 1.99;
  padding-bottom: 25px;
  color: #333333;
  padding-right: 12px;
  padding-left: 12px;
}
/*81*/
.faculdade_texto2 {
  font-family: 'PT Sans';
  color: #333333;
  line-height: 2.5;
  font-size: 17px;
  padding-right: 12px;
  padding-left: 12px;
  margin-top: 41px;
}

.faculdade_texto2.nomargintop{
  margin-top: 0;
}

.tc{
  display: flex;
  justify-content: center;
  flex-direction: column;
}

@media (max-width:1500px) {
  .wrap2 {
    padding-top: 70px;
    padding-bottom: 55px;
  }

  .faculdade_texto1 {
    line-height: 1.8;
    font-size: 24px;
    padding-bottom: 12px;
  }

}

@media (max-width:1024px) {
  .btn{
    width: 360px;
  }
}


@media (max-width: 839px) {
  .wrap2 .columns {
    padding-right: 0;
    padding-left: 0;
  }

}


@media (max-width: 767px){

  /*----*/
  .wrap2{
    padding-top: 25px;
    padding-bottom: 30px;
  }


  /*1452*/
  .faculdade_texto1 {
    padding-right: 0;
    padding-left: 0;
    font-size: 17px;
    line-height: 1.5;
  }

  /*1458 (.blockanimate)*/
  .tc{
    padding-right: 0!important;
    padding-left: 0!important;
  }

  /*1463*/
  .faculdade_texto2 {
    font-size: 14px;
    line-height: 2;
    font-family: 'PT Sans';
    color: #333333;
    margin-top: 0;
    margin-bottom: 45px;
  }

  .btn {
    width: 290px;
  }

}
</style>